export default __webpack_public_path__ + "static/media/spotify-clone.bffe3b2c.jpg";